/*
 * views/skiView.js
 * Ski View
 */

define('app/views/skiView',[
    'lib/event',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/skiLocationList',
    'hbs!app/views/templates/skiLiftTicketList',
    'bootstrap'
], function (Event, commonViewHelper, navbarTpl, breadcrumbsTpl, contentTpl, skiLocationListTpl, skiLiftTicketListTpl ) {
    var skiView = {
        app:app,
        event:$.extend({}, Event),
        module:"ski",
        render:function (template, data, breadcrumbs) {

        }
    };

    var setBreadCrumb = function (crumbText, crumbLink) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.ski = app.data.breadCrumbs.ski || [];
        var spliceCrumbsAt = -1,
            existingCrumb = $.grep(app.data.breadCrumbs.ski, function (crumb, index) {
                if (crumb.url==crumbLink) {
                    spliceCrumbsAt = index;
                    return true;
                }
                return false;
            }),
            currentCrumb = {name:crumbText, url:crumbLink};

        app.data.breadCrumbs.ski = existingCrumb.length ?
            $.merge(app.data.breadCrumbs.ski.slice(0, spliceCrumbsAt), [currentCrumb]) :
            $.merge(app.data.breadCrumbs.ski, [currentCrumb]);

        for (var i = 0; i < app.data.breadCrumbs.ski.length; i++) {
            app.data.breadCrumbs.ski[i].last = i == (app.data.breadCrumbs.ski.length - 1);
        }
    };

    skiView.event.listen('requestSkiLocationSelection', skiView, function (e, skiLocations) {
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.skiView.module
        }));
        app.data.breadCrumbs.ski = [
            {name:app.localization.ski.title, url:"#/ski", last:true}
        ];
        var skiDate = "",
            locations = [];
        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.skiPropertyIdsInCart.length > 0 || app.data.pmsPropertyIdsInCart.length > 0)) {
            locations = _.filter(skiLocations,function(x){
                return _.any(app.data.skiPropertyIdsInCart, function(y){ return y==x.PropertyId }) || _.any(app.data.pmsPropertyIdsInCart, function(y){ return y==x.PropertyId })
            })
            if (app.data.propertyIdsInCart.length == 1 && app.data.skiDateList[app.data.skiPropertyIdsInCart[0]] && app.data.skiDateList[app.data.skiPropertyIdsInCart[0]].length == 1) {
                skiDate = "/" + app.data.skiDateList[app.data.skiPropertyIdsInCart[0]][0];
            }
        } else {
            locations = skiLocations;
        }
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            services:app.data.serviceTypes,
            bannerMessage:app.localization.ski.marketing.bannerMessage,
            siteName:app.localization.siteName,
            backLink:app.customization.serverURL,
            service:service
        }));
        $('#content').addClass('skiLocationListTpl').html(skiLocationListTpl({
            Localization:app.localization,
            Customization:app.customization,
            skiLocations:locations,
            skiDate:skiDate,
            showitem: //$.firstOrOnly(skiLocations).LocationId
                $.isArray(skiLocations) && skiLocations.length==1
                    ? $.firstOrOnly(skiLocations).LocationId : ""
        }));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.ski
        }))
        commonViewHelper.showMessages();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);

        commonViewHelper.prepPMSRateForm();
        commonViewHelper.analyticsInit('requestSkiLocationSelection', [skiLocations]);
    });

    skiView.event.listen('requestSkiLiftTicketSelection', skiView, function (e, skiServices, itemId, location, date, selectedRecipient, user, group) {
        app.data.breadCrumbs.ski = [
            {name:app.localization.ski.location, url:"#/ski", last:true}
        ];

        setBreadCrumb(app.localization.ski.title, "#ski/liftTickets");


        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (arr) {
            return arr.id == 'ski'
        }));

        // PromoLiftTickets
        // LiftTickets.LiftTicket
        //Customization.skiBooking.itemClassDisplayOrder = [ 'package', 'program', 'pass', 'ticket', 'rental+insurance'];
        var itemTypes = {
            'package'  : { many: 'Packages', one: 'Package', hasPromos: true },
            'program'  : { many: 'Programs', one: 'Program', hasPromos: true },
            'pass'     : { many: 'Passes', one: 'Pass', hasPromos: true },
            'ticket'   : { many: 'LiftTickets', one: 'LiftTicket', hasPromos: true },
            'rental'   : { many: 'Rentals', one: 'Rental', hasPromos: true },
            'insurance': { many: 'InsuranceItems', one: 'InsuranceItem', hasPromos: false }
        }
        var categories=[],
            skiDate = Date.parse( date.substr(0,10), 'yyyy-MM-dd' ),
            weekDays = { 0: "Sunday", 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday" }
        _.each(app.customization.skiBooking.itemClassDisplayOrder, function(itemClassDisplayOrder){
            var itemClasses = itemClassDisplayOrder.split('+')
              , category = { 
                    category: Localization.ski['label'+itemClassDisplayOrder] || _.map(itemClasses,function(itemClass){return Localization.ski['label'+itemClass]}).join(' '),
                    items: {}
                }
            _.each(itemClasses, function(itemClass){
              
                if (skiServices[ itemTypes[itemClass].many ] && skiServices[ itemTypes[itemClass].many ][ itemTypes[itemClass].one ]) {
                    _.each(skiServices[ itemTypes[itemClass].many ][ itemTypes[itemClass].one ],function(item){
                        var allowedPromoCodes = app.customization.skiBooking.promoBasedSkiItems
                        if(!_.isEmpty(allowedPromoCodes)){
                            if(_.contains(allowedPromoCodes,item.ItemSubCategory) && item.ItemSubCategory != app.data.skiPromoCode)  return
                        }
                        var categoryName = item.ItemCategory || Localization.ski['label'+itemClass]
                        category.items[categoryName] = category.items[categoryName] || []
                        category.items[categoryName].push(item)
                    })

                }
                if (itemTypes[itemClass].hasPromos && skiServices[ 'Promo'+itemTypes[itemClass].many ] && skiServices[ 'Promo'+itemTypes[itemClass].many ][ itemTypes[itemClass].one ]) {
                    _.each(skiServices[ 'Promo'+itemTypes[itemClass].many ][ itemTypes[itemClass].one ],function(item){
                        var allowedPromoCodes = app.customization.skiBooking.promoBasedSkiItems
                        if(!_.isEmpty(allowedPromoCodes)){
                            if(_.contains(allowedPromoCodes,item.ItemSubCategory) && item.ItemSubCategory != app.data.skiPromoCode)  return
                        }
                        if (!!app.customization.skiBooking.groupPromoCategoriesIntoOne) {
                            category.items[app.localization.ski.promo] = category.items[app.localization.ski.promo] || []
                            category.items[app.localization.ski.promo].push(item)
                        } else {
                            var categoryName = item.ItemCategory || Localization.ski['label'+itemClass]
                            category.items[categoryName] = category.items[categoryName] || []
                            category.items[categoryName].push(item)
                        }
                    })
                }
            })
            category.items = _.map(category.items,function(val,key){ 
                return {
                    name:key, 
                    tickets: commonViewHelper.sortHelper(_.sortBy(val, function(s) {
                            return app.customization.skiBooking.sortByPrice ? +s.Price : s.ItemName
                        } ))
                } 
            })            
            category.items.length && categories.push(category)
        })
        var category = {}
        _.each(categories, function (x) {
            _.each(x.items, function (y) {
                _.each(y.tickets, function (z) {
                    if (z.SkiItemId && (z.SkiItemId == itemId))
                        category= {'category':x.category,'name':y.name}
                })
            })
        })
        // _.each(skiServices.LiftTicket, function (v, k, l) {
        //     l[k].value = _.sortBy(l[k].value, function (s) {
        //         return app.customization.skiBooking.sortByPrice ? +s.Price : s.ItemName
        //     });
        //     Customization.skiBooking.showPriceIncludingSurcharges
        //         && _.each(l[k].value, function(s,i){
        //             s.PriceWithSurcharges && (l[k].value[i].Price = s.PriceWithSurcharges);
        //         })
        // })
        // skiServices.LiftTicket = _.sortBy(skiServices.LiftTicket, function (s) {
        //     return s.name
        // });
        var templateData = {
            categories:categories,
            location:location,
            Customization:app.customization,
            Localization:app.localization,
            showitem:itemId,
            showcategory:category,
            selectedRecipient: selectedRecipient,
            user: user,
            group: group,
            skiDate: date+'000000',
            //anyLiftTickets: anyLiftTickets,
            //anyPromoLiftTickets: anyPromoLiftTickets,
            url: window.location.hash.replace(/^#/, ''),
            showBookForGroupMember: user.CustomerId && !app.customization.skiBooking.disallowBookForGroupMember,
            showSkiItemGuestNote: !!(app.customization.skiBooking.showSkiItemNote.skiItem === true 
                ||(typeof app.customization.skiBooking.showSkiItemNote.skiItem == "function" 
                    && app.customization.skiBooking.showSkiItemNote.skiItem.showSkiItemNote(item,customer))),
            showPkgItemGuestNote: !!(app.customization.skiBooking.showSkiItemNote.pkgItem === true 
                ||(typeof app.customization.skiBooking.showSkiItemNote.pkgItem == "function" 
                    && app.customization.skiBooking.showSkiItemNote.pkgItem.showPkgItemNote(item,customer)))
        };
        console.log(categories);
        $('#nav').html(navbarTpl({
            Localization:app.localization,
            Customization:app.customization,
            services:app.data.serviceTypes,
            languages:app.data.languageNames,
            siteName:app.localization.siteName,
            backLink:Customization.serverURL
        }));
        $('#main').html(contentTpl({
            Localization:app.localization,
            bannerMessage:app.localization.ski.marketing.bannerMessage,
            service:service
        }));
        $('#content').addClass('skiLiftTicketListTpl').html(skiLiftTicketListTpl(templateData));
        $('#breadcrumbs').html(breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.ski
        }))
        console.log(location, app.localization);
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.prepSkiForm(location, itemId, date, templateData,group);
        commonViewHelper.showMessages();

    });


    skiView.event.listen('updateMessages', skiView, function(e){
        var service = $.firstOrOnly($.grep(app.data.serviceTypes, function (a) {
            return a.id == app.views.skiView.module
        }));
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
    });

    return window.app.views.skiView = skiView;

});

